import React from 'react';

const About = () => {
	return (
		<section className="py-1 px-1">
            <div className="container-lg lg:px-28 pb-5">
				<div className="title text-center my-5">
                    <h2 className='text-4xl font-bold'>About us</h2>
                </div> 
				<p>Yum Yum is your go-to guide to restaurants in the cities near you! Covering major cities and the surrounding areas across the United States, you’ll find your next great meal out on Yum Yum.</p>
				<p>The team at Yum Yum is made up of foodies, food bloggers, and dining enthusiasts from across the country. Our reviews offer insight into the best restaurants in your area, so you can choose your next destination and find reservations all in one place. We’re a team of digital marketers with a passion for food, restaurants, and hospitality.</p>
			</div>
		</section>
	);
};

export default About;